<template>
  <div :style="{ width: '100%', height: '100%' }">
    <div class="emptyContainer" v-if="detailList.length === 0">暂无数据</div>
    <!-- 每个item -->
    <div id="historyItems" v-for="(item, index) in detailList" :key="index">
      <!-- 组合字符串 例如: [1. 2022-03-04 10:56:19, 由 刘福 创建。] -->
      {{ index + 1 }}. {{ item.todo9 }},&nbsp;由
      <span :style="{ fontWeight: 'bold' }">&nbsp;{{ item.todo10 }}&nbsp;</span>
      {{ item.todo11 }}。
      <!-- 备注是否含有富文本内容，含有的话v-html渲染出来 -->
      <div
        v-if="!!item.todo12"
        :style="{
          backgroundColor: '#f9f9f9',
          border: '1px solid #eeeeee',
          boxSizing: 'border-box',
          padding: '10px',
          marginTop: '5px',
          marginLeft: '10px',
        }"
        v-html="item.todo12"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detailList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
}
</script>
<style lang='less' scoped>
.emptyContainer {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #606266;
}
#historyItems {
  color: #3c4353;
  font-size: 14px;
  margin-bottom: 5px;
  div {
    width: calc(100% - 10px);
  }
}
</style>